import * as React from 'react';

function SvgCamera(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 19" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M12 7.12a3.57 3.57 0 103.6 3.57A3.59 3.59 0 0012 7.12zm9.6-3.56h-2.88a1.07 1.07 0 01-.95-.67L17 .68A1.06 1.06 0 0016 0H7.92A1.07 1.07 0 007 .67l-.77 2.22a1.07 1.07 0 01-1 .67H2.4A2.4 2.4 0 000 5.94v10.68A2.4 2.4 0 002.4 19h19.2a2.4 2.4 0 002.4-2.38V5.94a2.4 2.4 0 00-2.4-2.38zM12 16.62a5.94 5.94 0 116-5.93 6 6 0 01-6 5.93zm9-9.26a.83.83 0 11.84-.83.84.84 0 01-.84.83z" />
    </svg>
  );
}

const MemoSvgCamera = React.memo(SvgCamera);
export default MemoSvgCamera;
